import React from "react";
import "./styles/Information.css";
import Footer from "../components/Footer";
import { connect } from "react-redux";
import ideaIcon from "../assets/idea.svg";

const CONTENT = {
  es: {
    title: "¿Por qué Donar o Intercambiar?",
    paragraphs: [
      "El sitio se creó con el fin de apoyar la economía de los usuarios, la cual últimamente ha venido reduciéndose. Con la ola de consumismo se adquieren artículos que ya no se necesitan y otros sí; así, cuando dispongan de algún producto, artículo o bien que actualmente ya no usen, podrán realizar intercambios por artículos que estén necesitando, bienes que otros usuarios no estén usando. Del mismo modo, las donaciones: cuando otras personas hayan sufrido alguna eventualidad o necesidad y se desee apoyarlas, se podrán publicar donaciones y donarlas a personas que las necesiten directamente o a intermediarios como fundaciones, grupos o movimientos que distribuyen directamente a quienes las necesitan.",
      "Te recomendamos, antes de cualquier transacción, consultar todos los datos técnicos y características a detalle que requieras, para no tener sorpresas ni inconvenientes en el momento de recibir lo anunciado.",
      "Para mayor seguridad revisa la calificación del anunciante, y si ya has solicitado la transacción en el sitio y no estás seguro, igual la puedes cancelar en cualquier momento.",
      "Si el anunciante no dispone de un lugar comercial, te recomendamos que las compras, intercambios y donaciones las realices en lugares públicos.",
      "La calificación del anunciante se realiza sumando las ventas solicitadas en el sitio, verificando cuántas han sido completadas y cuántas han sido canceladas.",
    ],
  },
  en: {
    title: "Why Donate or Exchange?",
    paragraphs: [
      "The site was created in order to support the economy of the users, which lately has been shrinking. With the wave of consumerism, items that are no longer needed are purchased, and others that are; so when they have a product, article or good that they no longer use, they can make exchanges for items they need, goods that other users are not using. Likewise, donations: when other people have suffered some eventuality or need and you want to support them, you can publish donations and donate them to people who need them directly, or in turn to intermediaries like foundations, groups or movements that distribute directly to people who need them.",
      "We recommend that before any transaction you consult all the technical data and characteristics in detail that you require, so as not to have surprises or inconveniences when you receive what is announced.",
      "For more security, check the advertiser's rating, and if you have already requested the transaction on the site and are not sure, you can still cancel it at any time.",
      "If the advertiser does not have a commercial place, we recommend that you carry out purchases, exchanges and donations in public places.",
      "The advertiser's rating is done by adding up the sales requested on the site, verifying how many have been completed and how many have been canceled.",
    ],
  },
};

class WhyDonationExchange extends React.Component {
  render() {
    const content = this.props.lang === "es" ? CONTENT.es : CONTENT.en;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="container-information">
            <div className="info-card">
              <div className="info-card__header">
                <span className="info-card__icon">
                  <img src={ideaIcon} alt="" aria-hidden="true" />
                </span>
                <h1 className="info-card__title">{content.title}</h1>
              </div>
              <div className="info-card__body">
                {content.paragraphs.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale,
  };
}

export default connect(mapStateToProps, null)(WhyDonationExchange);
